import { Button, Form, Modal } from "antd";
import React from "react";
import { InputOTP } from "antd-input-otp";
import Title from "antd/lib/typography/Title";
import { UndoOutlined } from "@ant-design/icons";
import { verityOTP } from "../../Services/e-pro/SupplierService";
import { Space, Spin } from "antd";

type Props = {
  visible: boolean;
  onOk: (isOtpCorrect: boolean) => void;
  onClose: () => void;
  confirmOTP?: any;
};

const OTPModal: React.FC<Props> = ({ visible, onOk, onClose, confirmOTP }) => {
  const [form] = Form.useForm();
  const [loading, setloading] = React.useState<boolean>(false);
  const [feildMessage, setFeildMessage] = React.useState<
    string | undefined | null
  >();

  const [time, setTime] = React.useState(10);

  React.useEffect(() => {
    let interval: NodeJS.Timer;
    if (visible && confirmOTP && confirmOTP.Duration) {
      setTime(confirmOTP.Duration);
      interval = setInterval(() => {
        setTime((prevTime) => Math.max(prevTime - 1, 0));
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [visible, confirmOTP]);

  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    return `${minutes.toString().padStart(2, "0")}:${remainingSeconds
      .toString()
      .padStart(2, "0")}`;
  };

  const handleFinish = async (values: any) => {
    setloading(true);
    const otp = values.otp.join("");
    const response = await verityOTP({
      OTP: otp,
      Ref_Code: confirmOTP?.Ref,
      TelMobile: confirmOTP?.TelMobile,
    });
    setTimeout(() => {
      if (response?.data.isSuccess) {
        setloading(false);
        onOk(true);
      } else {
        setFeildMessage("OTP ไม่ถูกต้อง");
        setloading(false);
        onOk(false);
      }
    }, 1000);
  };

  return (
    <Modal
      visible={visible}
      centered
      onCancel={onClose}
      width={900}
      footer={null}
      maskClosable={false}
      closable={false}
      className="custom-modal"
      style={{
        backgroundColor: "rgba(255, 255, 255, 0.3)",
        backdropFilter: "blur(10px)",
        borderRadius: "10px",
      }}
      afterClose={() => form.resetFields()}
    >
      <Title
        level={2}
        style={{ textAlign: "center", color: "#ffffff", marginBottom: "30px" }}
      >
        ระบบได้ส่งรหัส OTP ไปยังเบอร์โทรศัพท์ ({confirmOTP?.TelMobile})
      </Title>
      <div
        style={{
          marginBottom: "20px",
          color: "#ffffff",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Button
          onClick={onClose}
          style={{
            fontSize: "20px",
            width: "250px",
            height: "50px",
            borderRadius: "10px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
            border: "2px solid #C95559",
            color: "#C95559",
          }}
        >
          <UndoOutlined rev={undefined} />
          ขอรหัส OTP ใหม่
        </Button>
      </div>
      <div
        style={{
          marginBottom: "20px",
          color: "#ffffff",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "20px",
        }}
      >
        รหัสอ้างอิง : {confirmOTP?.Ref}
      </div>
      <div
        style={{
          marginBottom: "20px",
          color: "#ffffff",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "20px",
        }}
      >
        รหัส OTP ที่ได้รับ ( โปรดระบุภายใน {formatTime(time)} นาที )
      </div>
      {loading ? (
        <Space
          style={{ display: "flex", width: "100%", justifyContent: "center" }}
        >
          <Spin size="large" />
        </Space>
      ) : (
        <Form form={form} onFinish={handleFinish}>
          <Form.Item name="otp">
            <InputOTP autoSubmit={form} inputType="numeric" />
          </Form.Item>
          {feildMessage && (
            <Space
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                color: "red",
                marginTop: "20px",
              }}
            >
              {feildMessage}
            </Space>
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "50px",
              marginTop: "40px",
            }}
          >
            <Button
              onClick={onClose}
              style={{
                marginBottom: "16px",
                width: "150px",
                display: "flex",
                justifyContent: "center",
                textAlign: "center",
                alignItems: "center",
                backgroundColor: "#C95559",
                borderRadius: "10px",
                border: "none",
                height: "50px",
                fontSize: "20px",
                color: "#ffffff",
              }}
            >
              ยกเลิก
            </Button>
          </div>
        </Form>
      )}
    </Modal>
  );
};

export default OTPModal;
